module.exports = __webpack_public_path__ + "static/img/new_bg.3b8f611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_bg.png
// module id = oI6D
// module chunks = 1